/**
 * Universal Compressor - Homepage
 * Accepts all supported formats: JPG, PNG, WebP, AVIF, PDF
 */
import { createApp } from 'vue';
import UniversalCompressor from '@/Components/UniversalCompressor.vue';
import '@styles/app.css';

createApp(UniversalCompressor).mount('#universal-compressor');
